import { render, staticRenderFns } from "./function_tabs.vue?vue&type=template&id=546ed44f"
import script from "./function_tabs.vue?vue&type=script&lang=js"
export * from "./function_tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports